import './chunk-851d1b8f.js';
import './helpers.js';
import './chunk-e92e3389.js';
import './chunk-6ca75105.js';
import './chunk-4b289821.js';
import { r as registerComponent, u as use } from './chunk-cca88db8.js';
import './chunk-d77d421b.js';
import './chunk-70481141.js';
import './chunk-42f463e6.js';
import './chunk-0c67e5e7.js';
import './chunk-6a7209ee.js';
import './chunk-bf29bc31.js';
import { D as Datepicker } from './chunk-dc931ea5.js';
export { D as BDatepicker } from './chunk-dc931ea5.js';
var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, Datepicker);
  }
};
use(Plugin);
export default Plugin;